import Ethnicity from 'src/app/models/ethnicity';
import { Component, OnInit, Output, EventEmitter, Input, ViewEncapsulation, ElementRef, ViewChild, OnChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { find, filter, cloneDeep, remove, some, get, map, sortBy } from 'lodash';
import * as dayjs from 'dayjs';
import Member from 'src/app/models/member';
import MemberEthnicity from 'src/app/models/memberEthnicity';
import PreferredAccessibleFormat from 'src/app/models/preferredAccessibleFormat';

/**
 * Used to display/edit race/ethnicity fields for selfpay forms and wizard
 */
@Component({
  selector: 'race-ethnicity',
  templateUrl: 'race-ethnicity.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None,
})
export class RaceEthnicityComponent implements OnInit {
  @Input() ethnicities: MemberEthnicity[];
  @Input() member: Member;
  @Input() selfPayForm = false;
  @Input() ethnicityIndex: string = "";
  @Input() lookups;
  @Output() saveMemberEthnicities: EventEmitter<MemberEthnicity[]> = new EventEmitter<MemberEthnicity[]>();
  @Output() updateMemberObject: EventEmitter<MemberEthnicity[]> = new EventEmitter<MemberEthnicity[]>();
  hispanicEthnicities: MemberEthnicity[]
  races: MemberEthnicity[];
  preferredAccessibleFormats: PreferredAccessibleFormat[];
  selectedLanguage: string;
  otherLanguageEnabled = false;
  selectedEthnicities: MemberEthnicity[] = [];
  @Input() suppressSave = false;
  noAnswerEth: MemberEthnicity;
  noAnswerRace: MemberEthnicity;
  noAnswerPreferredAccessibleFormat: PreferredAccessibleFormat;
  constructor() {}

  ngOnInit() {
    this.noAnswerEth = find(this.ethnicities, (e) => e.ethnicityCode == 'CNA' && e.uhcEthnicityCode != null);
    this.noAnswerRace = find(this.ethnicities, (e) => e.ethnicityCode == 'CNAR' && e.uhcRaceCode != null);
    this.noAnswerPreferredAccessibleFormat = find(this.lookups?.preferredAccessibleFormats, (e) => e.preferredAccessibleFormatCode == 'NSP');
    this.hispanicEthnicities = sortBy(filter(this.ethnicities, (e => e.uhcEthnicityCode != null && e.uhcEthnicityCode != '7')),'sortOrder');
    this.races = sortBy(filter(this.ethnicities, (e => e.uhcRaceCode != null && e.uhcRaceCode != '7')),'sortOrder');
    this.preferredAccessibleFormats = this.lookups?.preferredAccessibleFormats;
    this.setMemberRaceAndEthnicities();
  }

  ngOnChanges(): void {
    this.setMemberRaceAndEthnicities();
  }

  setMemberRaceAndEthnicities() {
    if (this.member?.memberEthnicities) {
      this.selectedEthnicities = this.member?.memberEthnicities;
    }
  }

  updateEthnicities(ethnicityId: string, raceOrEth: string) {
    if(ethnicityId == this.noAnswerEth.ethnicityId && raceOrEth == "ethnicity") {
      remove(this.selectedEthnicities, (s: MemberEthnicity) => some(this.hispanicEthnicities, (e: Ethnicity) => e.ethnicityId === s.ethnicityId));
      this.selectedEthnicities.push(this.noAnswerEth)
    }else if(ethnicityId == this.noAnswerRace.ethnicityId && raceOrEth == "race") {
      remove(this.selectedEthnicities, (s: MemberEthnicity) => some(this.races, (e: Ethnicity) => e.ethnicityId === s.ethnicityId));
      this.selectedEthnicities.push(this.noAnswerRace)
    } else {
      var selectedEthnicity = find(this.selectedEthnicities, (e) => e.ethnicityId == ethnicityId);
      if(!selectedEthnicity) {
        var newEthnicitySelection = find(this.ethnicities, (e) => e.ethnicityId == ethnicityId);
        this.selectedEthnicities.push(newEthnicitySelection);
        remove(this.selectedEthnicities, (e) => e.ethnicityId == this.noAnswerEth.ethnicityId);
        if(some(this.selectedEthnicities, (s: MemberEthnicity) => some(this.races, (e: Ethnicity) => e.ethnicityId === s.ethnicityId))) {
          remove(this.selectedEthnicities, (e) => e.ethnicityId == this.noAnswerRace.ethnicityId);
        }else if(some(this.selectedEthnicities, (s: MemberEthnicity) => some(this.hispanicEthnicities, (e: Ethnicity) => e.ethnicityId === s.ethnicityId))) {
          remove(this.selectedEthnicities, (e) => e.ethnicityId == this.noAnswerEth.ethnicityId)
        }
      }else {
        remove(this.selectedEthnicities, (e) => e.ethnicityId == ethnicityId);
      }
    }
    this.updateMemberObject.emit(this.selectedEthnicities);
  }

  save() {
    this.saveMemberEthnicities.emit(this.selectedEthnicities);
  }

  ethnicityIsSelected(ethnicityId) {
    return find(this.selectedEthnicities,(eth: Ethnicity) => eth.ethnicityId == ethnicityId);
  }

  otherLanguageChange(otherLanguageChangeVal) {
    this.member.otherSelectedLanguage = "";
    if (!this.member.otherLanguageEnabled) {
      this.member.otherLanguageEnabled = true;
      this.member.selectedLanguage = "";
    }
    else {
      this.member.otherLanguageEnabled = false;
    }
  }

  setLanguage(language) {
    this.member.selectedLanguage = language;
    this.member.otherLanguageEnabled = false;
    this.member.otherSelectedLanguage = "";
  }

  setPreferredAccessibleFormat(preferredAccessibleFormatId) {
    if(preferredAccessibleFormatId == this.noAnswerPreferredAccessibleFormat.preferredAccessibleFormatId) {
      remove(this.member.preferredAccessibleFormats, (s: PreferredAccessibleFormat) => some(this.preferredAccessibleFormats, (e: PreferredAccessibleFormat) => e.preferredAccessibleFormatId === s.preferredAccessibleFormatId));
      this.member.preferredAccessibleFormats.push(this.noAnswerPreferredAccessibleFormat);
    }
    else {
      var selectedPreferredAccessibleFormat = find(this.member.preferredAccessibleFormats, (e) => e.preferredAccessibleFormatId == preferredAccessibleFormatId);
      if(!selectedPreferredAccessibleFormat) {
        var newpreferredAccessibleFormatSelection = find(this.preferredAccessibleFormats, (e) => e.preferredAccessibleFormatId == preferredAccessibleFormatId);
        this.member.preferredAccessibleFormats.push(newpreferredAccessibleFormatSelection);
      } else {
        remove(this.member.preferredAccessibleFormats, (e) => e.preferredAccessibleFormatId == preferredAccessibleFormatId);
      }

      if(some(this.member.preferredAccessibleFormats, (s: PreferredAccessibleFormat) => some(this.preferredAccessibleFormats, (e: PreferredAccessibleFormat) => e.preferredAccessibleFormatId === s.preferredAccessibleFormatId))) {
          remove(this.member.preferredAccessibleFormats, (e) => e.preferredAccessibleFormatId == this.noAnswerPreferredAccessibleFormat.preferredAccessibleFormatId);
      }
    }
  }

  preferredAccessibleFormatIsSelected(preferredAccessibleFormatId) {
    return this.member.preferredAccessibleFormats && find(this.member.preferredAccessibleFormats, (e) => e.preferredAccessibleFormatId == preferredAccessibleFormatId);
  }
}

